import { createSlice } from '@reduxjs/toolkit';

import { patientApi } from '../api/patientApi';

import type { PayloadAction } from '@reduxjs/toolkit';

type AppState = {
  appVariant: string,
  dischargePrompt: boolean,
  ehrLogin: boolean;
  procedureLogo: string | null,
  route: string | null,
  secureMessagingEnabled: boolean;
  testEnv: boolean,
  unitPref: string | null,
};

const initialState = {
  appVariant: 'seamless',
  dischargePrompt: true,
  ehrLogin: false,
  route: null,
  testEnv: false,
  secureMessagingEnabled: false,
  unitPref: null,
} as AppState;

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppVariant: (
      state,
      { payload: appVariant }: PayloadAction<string>,
    ) => {
      state.appVariant = appVariant;
    },
    setDischargePrompt: (
      state,
      { payload: dischargePrompt }: PayloadAction<boolean>,
    ) => {
      state.dischargePrompt = dischargePrompt;
    },
    setEhrLogin: (
      state,
      { payload: ehrLogin }: PayloadAction<boolean>,
    ) => {
      state.ehrLogin = ehrLogin;
    },
    setRoute: (
      state,
      { payload: route }: PayloadAction<string>,
    ) => {
      state.route = route;
    },
    setTestEnv: (
      state,
      { payload: testEnv }: PayloadAction<boolean>,
    ) => {
      state.testEnv = testEnv;
    },
    setUnitPref: (
      state,
      { payload: unitPref }: PayloadAction<string>,
    ) => {
      state.unitPref = unitPref;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        patientApi.endpoints.getPatient.matchFulfilled,
        (state, { payload }) => {
          if (payload.server === 'US') {
            state.unitPref = 'imperial';
          }
          if (payload.server === 'CA') {
            state.unitPref = 'metric';
          }
        },
      )
      .addMatcher(
        patientApi.endpoints.getPatient.matchFulfilled,
        (state, { payload }) => {
          state.procedureLogo = payload.procedureLogo;
          state.secureMessagingEnabled = payload.secureMessagingEnabled;
        },
      )
  },
});

export const {
  setAppVariant,
  setDischargePrompt,
  setEhrLogin,
  setRoute,
  setTestEnv,
  setUnitPref,
} = slice.actions;

export default slice.reducer;
